import { QuestionCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const TooltipIcon = styled(QuestionCircleOutlined)`
  font-size: 12px;
  color: var(--gray-8);
`;
